{
    "ModalTitleStatusChange": "Aanmelden voor ACD-agent",
    "LocationStatusTitle": "Plaats",
    "LocationStatusDescription": "Kies een apparaat en ACD-agent om in te loggen.",
    "StatusOptionsTitle": "Afdrukuitvoeropties",
    "AcdGroupOptionsDescription": "Als de doeltelefoonserver dit ondersteunt, kunt u de ACD-groep kiezen waarvoor de geselecteerde ACD-status specifiek wordt gewijzigd.",
    "AcdGroupLabel": "ACD-groep",
    "AcdAgentLabel": "ACD-agent",
    "FooterButtonOk": "Oke",
    "FooterButtonCancel": "Annuleren",
    "FooterButtonHelp": "Helpen?",
    "StatusChange_PromptMessage": "Bij het sluiten gaan alle configuraties verloren. Weet u zeker dat u dit venster wilt sluiten?",
    "StatusChange_PromptConfirm": "Ja",
    "StatusChange_PromptCancel": "Annuleren",
    "StatusChange_DevicesLabel": "Apparaat",
    "NAME": "StatusChange"
}